import Badge from './Badge';
import Breadcrumbs from './Breadcrumbs';
import Button from './Button';
import Card from './Card';
import Checkbox from './Checkbox';
import Collapse from './Collapse';
import Container from './Container';
import Copy from './Copy';
import Flex from './Flex';
import Grid from './Grid';
import Radio from './Radio';
import Select from './Select';
import * as Separator from './Separator';
import Tabs from './Tabs';
import Text from './Text';
import Tooltip from './Tooltip';

const UiKit = {
  Badge,
  Breadcrumbs,
  Button,
  Card,
  Checkbox,
  Collapse,
  Container,
  Copy,
  Flex,
  Grid,
  Radio,
  Select,
  Separator,
  Tabs,
  Text,
  Tooltip,
};

export default UiKit;
